// src/components/AttendanceWeekdayTab.js
import React from 'react';

const AttendanceWeekdayTab = ({
  students,
  weekdayDates,
  selectedWeekdayDate,
  setSelectedWeekdayDate,
  displayedWeekdayDates,
  getAttendanceClass,
  handleEditAttendance,
  formatDisplayDate,
}) => {
  return (
    <>
      <h4>Điểm danh Đi Lễ Ngày Thường</h4>
      <table className="student-table">
        <thead>
          <tr>
            <th>Stt</th>
            <th>ID</th>
            <th>Tên Thánh</th>
            <th className="sticky-name-col">Họ và Tên</th>
            <th className="mobile-only">
              <select value={selectedWeekdayDate} onChange={(e) => setSelectedWeekdayDate(e.target.value)}>
                {weekdayDates.slice().reverse().map((date, index) => (
                  <option key={index} value={date}>{formatDisplayDate(date)}</option>
                ))}
              </select>
            </th>
            {displayedWeekdayDates.map((date, index) => (
              <th key={index} className="desktop-only">{formatDisplayDate(date)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {students.map((student, index) => (
            <tr key={student.id || index}>
              <td>{index + 1}</td>
              <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>{student.id}</td>
              <td>{student.holyName || '-'}</td>
              <td className="sticky-name-col">{student.fullName}</td>
              <td className="mobile-only">
                <button
                  className={getAttendanceClass(student.attendance?.[selectedWeekdayDate]?.time).className}
                  disabled={getAttendanceClass(student.attendance?.[selectedWeekdayDate]?.time).isDisabled}
                  onClick={() => handleEditAttendance(student, selectedWeekdayDate, 'church')}
                >
                  {student.attendance?.[selectedWeekdayDate]?.time || 'Vắng không xin phép'}
                </button>
              </td>
              {displayedWeekdayDates.map((date, idx) => (
                <td key={idx} className="desktop-only">
                  <button
                    className={getAttendanceClass(student.attendance?.[date]?.time).className}
                    disabled={getAttendanceClass(student.attendance?.[date]?.time).isDisabled}
                    onClick={() => handleEditAttendance(student, date, 'church')}
                  >
                    {student.attendance?.[date]?.time || 'Vắng không xin phép'}
                  </button>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

export default AttendanceWeekdayTab;